module.exports = __webpack_public_path__ + "static/media/swimming.ec22cfee.jpg";